import React, { useEffect } from 'react';
import { 
    Avatar, Box, Button, Container, Grid, Paper, 
    Typography, Stack, Chip, useTheme 
} from '@mui/material';
import { motion } from "framer-motion";
import { useHistory } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faTicket, faStore, faCalendarCheck, faQrcode, 
    faGift, faUtensils, faMapLocationDot, faBolt
} from '@fortawesome/free-solid-svg-icons';
import { faApple, faGooglePlay } from '@fortawesome/free-brands-svg-icons';

// Importa tu componente de contacto
import ContactUs2 from './contactUs2';

// Imagen de Hero (Asegúrate de tener una imagen atractiva aquí, un mockup del celular con la app se vería brutal)
import heroImg from '../../assets/images/t6.png'; 

export default function ForPeople() {
    const history = useHistory();
    const theme = useTheme();

    const redirect = (route) => {
        history.push(route);
    };

    useEffect(()=>{
        window.scrollTo(0,0);
    },[])

    // Variantes de animación
    const fadeUp = {
        hidden: { opacity: 0, y: 40 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
    };

    // Componente de Tarjeta Bento
    const FeatureCard = ({ icon, title, desc, color, bgcolor, isLarge = false }) => (
        <Paper elevation={0} sx={{
            p: { xs: 4, md: 5 },
            height: '100%',
            borderRadius: 6,
            bgcolor: bgcolor || '#f8fafc',
            border: '1px solid #e2e8f0',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            overflow: 'hidden',
            transition: 'transform 0.3s ease, border-color 0.3s ease',
            '&:hover': { 
                transform: 'translateY(-5px)',
                borderColor: '#cbd5e1'
            }
        }}>
            {/* Ícono de fondo marca de agua */}
            <Box sx={{ position: 'absolute', right: -20, bottom: -20, opacity: 0.03, transform: 'rotate(-15deg)' }}>
                <FontAwesomeIcon icon={icon} style={{ fontSize: '180px', color: '#000' }} />
            </Box>

            <Avatar sx={{ bgcolor: 'white', color: color, width: 60, height: 60, mb: 3, border: '1px solid #e2e8f0', boxShadow: '0 4px 10px rgba(0,0,0,0.05)' }}>
                <FontAwesomeIcon icon={icon} fontSize="1.5rem" />
            </Avatar>
            <Typography variant={isLarge ? "h4" : "h5"} fontWeight="800" color="text.primary" mb={2} zIndex={1}>
                {title}
            </Typography>
            <Typography variant="body1" color="text.secondary" fontWeight="500" sx={{ lineHeight: 1.6, fontSize: '1.05rem' }} zIndex={1}>
                {desc}
            </Typography>
        </Paper>
    );

    return (
        <Box sx={{ bgcolor: '#ffffff', minHeight: '100vh', pt: { xs: 12, md: 16 } }}>
            
            {/* ==========================================
                BLOQUE 1: HERO SECTION (Lifestyle & Super App)
            ========================================== */}
            <Container maxWidth="xl">
                <Grid container spacing={6} alignItems="center" sx={{ minHeight: '70vh' }}>
                    <Grid item xs={12} md={6}>
                        <motion.div initial="hidden" animate="visible" variants={fadeUp}>
                            <Chip 
                                label="LA SUPER APP LOCAL" 
                                sx={{ bgcolor: '#f1f5f9', color: '#64748b', fontWeight: '800', mb: 3, letterSpacing: 1 }} 
                            />
                            
                            <Typography variant='h2' component='h1' fontWeight='900' color='text.primary' sx={{ lineHeight: 1.1, mb: 3, fontSize: { xs: '3rem', md: '4.5rem' }, letterSpacing: '-1.5px' }}>
                                Tu ciudad entera, en la <Typography component="span" variant="inherit" color="primary.main">palma de tu mano.</Typography>
                            </Typography>
                            
                            <Typography variant='h6' color='text.secondary' sx={{ mb: 5, fontWeight: 500, maxWidth: '90%', lineHeight: 1.6 }}>
                                Dile adiós a tener 10 aplicaciones distintas. Con QUD exploras comercios, compras entradas, haces reservas y pagas sin efectivo desde un solo lugar.
                            </Typography>
                            
                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} mb={6}>
                                <Button 
                                    variant='contained' 
                                    size="large"
                                    onClick={() => redirect('/auth/userType')}
                                    sx={{ borderRadius: 8, px: 5, py: 1.8, fontSize: '1.1rem', fontWeight: 'bold', textTransform: 'none', boxShadow: '0 8px 20px rgba(20, 122, 194, 0.3)' }} 
                                >
                                    Crear cuenta gratis
                                </Button>
                            </Stack>

                            {/* Trust Indicators de Usuarios */}
                            <Stack direction="row" spacing={4} alignItems="center">
                                <Box>
                                    <Typography variant="h4" fontWeight="900" color="text.primary">100%</Typography>
                                    <Typography variant="caption" color="text.secondary" fontWeight="bold">Seguro y Cashless</Typography>
                                </Box>
                                <Box sx={{ width: '1px', height: '40px', bgcolor: '#e2e8f0' }} />
                                <Box>
                                    <Typography variant="h4" fontWeight="900" color="text.primary">+100</Typography>
                                    <Typography variant="caption" color="text.secondary" fontWeight="bold">Comercios Locales</Typography>
                                </Box>
                            </Stack>
                        </motion.div>
                    </Grid>
                    
                    <Grid item xs={12} md={6}>
                        <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.8 }}>
                            <Box sx={{ position: 'relative', display: 'flex', justifyContent: 'center' }}>
                                {/* Círculo decorativo de fondo */}
                                <Box sx={{ position: 'absolute', top: '10%', right: '10%', width: '80%', height: '80%', bgcolor: 'primary.light', opacity: 0.15, borderRadius: '50%', filter: 'blur(60px)', zIndex: 0 }} />
                                <img 
                                    src={heroImg} 
                                    alt='QUD Super App' 
                                    style={{ width: '85%', maxWidth: '500px', borderRadius:20, position: 'relative', zIndex: 1, filter: 'drop-shadow(0 25px 50px rgba(0,0,0,0.15))' }} 
                                />
                            </Box>
                        </motion.div>
                    </Grid>
                </Grid>
            </Container>

            {/* ==========================================
                BLOQUE 2: BENTO BOX (Los Súper Poderes del Usuario)
            ========================================== */}
            <Box sx={{ bgcolor: '#f8fafc', py: { xs: 10, md: 15 }, mt: 10, borderTop: '1px solid #f1f5f9' }}>
                <Container maxWidth="xl">
                    <Box textAlign="center" mb={10} maxWidth="700px" mx="auto">
                        <Typography variant="h3" fontWeight="900" color="text.primary" mb={2}>
                            Todo lo que necesitas, a un <Typography component="span" variant="inherit" color="primary.main">solo toque.</Typography>
                        </Typography>
                        <Typography variant="h6" color="text.secondary" fontWeight="400">
                            Descubre cómo QUD transforma tu manera de interactuar con los comercios y eventos de tu ciudad.
                        </Typography>
                    </Box>

                    <Grid container spacing={3}>
                        {/* Fila 1 */}
                        <Grid item xs={12} md={7}>
                            <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeUp} style={{ height: '100%' }}>
                                <FeatureCard 
                                    isLarge
                                    icon={faTicket} color="#147ac2"
                                    title="Eventos y Ticketing Cashless"
                                    desc="Compra entradas para tus eventos favoritos y olvídate del efectivo. Usa tu código QR para entrar y paga las bebidas directamente con el saldo de tu app QUD. Cero filas, cero estrés."
                                />
                            </motion.div>
                        </Grid>
                        <Grid item xs={12} md={5}>
                            <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeUp} style={{ height: '100%' }}>
                                <FeatureCard 
                                    icon={faUtensils} color="#f59e0b"
                                    title="Pide en la mesa o a domicilio"
                                    desc="Escanea el código QR en tu restaurante favorito, arma tu pedido desde el celular y paga al instante. O simplemente pide para llevar desde la comodidad de tu casa."
                                />
                            </motion.div>
                        </Grid>

                        {/* Fila 2 */}
                        <Grid item xs={12} md={4}>
                            <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeUp} style={{ height: '100%' }}>
                                <FeatureCard 
                                    icon={faCalendarCheck} color="#8b5cf6"
                                    title="Reservas en segundos"
                                    desc="Agenda citas en barberías, clínicas o reserva tu mesa ideal sin tener que hacer ni una sola llamada telefónica."
                                />
                            </motion.div>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeUp} style={{ height: '100%' }}>
                                <FeatureCard 
                                    icon={faMapLocationDot} color="#10b981"
                                    title="Descubre joyas locales"
                                    desc="Explora el directorio interactivo de QUD para encontrar nuevos comercios, menús ocultos y servicios de primera cerca de ti."
                                />
                            </motion.div>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeUp} style={{ height: '100%' }}>
                                <FeatureCard 
                                    icon={faGift} color="#ec4899"
                                    title="Recompensas y Cupones"
                                    desc="Gana puntos por tus consumos, recibe cupones exclusivos por tu cumpleaños y desbloquea descuentos solo por pertenecer a la comunidad."
                                />
                            </motion.div>
                        </Grid>
                    </Grid>
                </Container>
            </Box>

            {/* ==========================================
                BLOQUE 3: CALL TO ACTION (Descarga/Registro)
            ========================================== */}
            <Box sx={{ py: { xs: 10, md: 15 }, bgcolor: 'white' }}>
                <Container maxWidth="xl">
                    <Paper elevation={0} sx={{ 
                        p: { xs: 5, md: 8 }, 
                        borderRadius: 8, 
                        bgcolor: '#0f172a', // Fondo oscuro elegante
                        backgroundImage: 'linear-gradient(to bottom right, #0f172a, #1e3a8a)',
                        color: 'white',
                        textAlign: 'center',
                        position: 'relative',
                        overflow: 'hidden'
                    }}>
                        {/* Rayos de luz decorativos */}
                        <Box sx={{ position: 'absolute', top: '-50%', left: '50%', transform: 'translateX(-50%)', width: '100%', height: '100%', bgcolor: 'rgba(20, 122, 194, 0.4)', filter: 'blur(120px)', borderRadius: '50%' }} />

                        <Box position="relative" zIndex={1}>
                            <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.1)', color: '#60a5fa', width: 80, height: 80, mx: 'auto', mb: 4 }}>
                                <FontAwesomeIcon icon={faBolt} size="2x" />
                            </Avatar>
                            <Typography variant="h3" fontWeight="900" mb={3}>
                                Listo para subir de nivel.
                            </Typography>
                            <Typography variant="h6" fontWeight="400" sx={{ opacity: 0.9, maxWidth: '600px', mx: 'auto', mb: 6, lineHeight: 1.6 }}>
                                Únete a miles de personas que ya disfrutan de la forma más rápida, segura y moderna de conectar con su ciudad.
                            </Typography>

                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={3} justifyContent="center" alignItems="center">
                                <Button 
                                    variant="contained" 
                                    size="large"
                                    onClick={() => redirect('/auth/userType')}
                                    sx={{ 
                                        bgcolor: 'white', 
                                        color: '#0f172a', 
                                        px: 5, 
                                        py: 2, 
                                        borderRadius: 8, 
                                        fontSize: '1.1rem', 
                                        fontWeight: '900',
                                        '&:hover': { bgcolor: '#f1f5f9' }
                                    }}
                                >
                                    Crear cuenta ahora
                                </Button>
                            </Stack>
                        </Box>
                    </Paper>
                </Container>
            </Box>

            {/* ==========================================
                CONTACTO FINAL
            ========================================== */}
            <ContactUs2
                title="¿Tienes alguna pregunta?"
                description="Nuestro equipo de soporte está siempre disponible para ayudarte a sacar el máximo provecho de tu experiencia QUD."
            />
            
        </Box>
    );
}